import React from 'react';
import { motion } from 'framer-motion';

export default function PageHeader({ title, onBack }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed top-0 left-0 right-0 z-50 bg-ivory-50/80 backdrop-blur-xl"
    >
      <div className="max-w-md mx-auto flex items-center px-4 py-3">
        <button
          onClick={onBack}
          className="flex items-center gap-1 text-sage-600 active:text-sage-800 transition-colors -ml-1"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          <span className="text-sm font-medium">Geri</span>
        </button>
        <span className="flex-1 text-center font-playfair text-sage-700 text-sm font-semibold pr-12">
          {title}
        </span>
      </div>
      <div className="h-px bg-sage-200/40" />
    </motion.div>
  );
}
